import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const DropDownContainer = styled('div')`
  width: 57px;
  height: 40px;
  cursor: pointer;
`;

export const DropDownHeader = styled('div')`
  background: ${() => Palette.Primary._500};
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${() => Palette.PrimaryGray._200};
  color: #ffffff;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.04);

  svg {
    margin-left: auto;
    fill: ${({ isOpen }) => (!isOpen ? Palette.PrimaryGray._400 : Palette.Primary._500)};
  }
  :hover {
    border: 1px solid ${() => Palette.PrimaryGray._300};
  }
  ${({ isOpen }) =>
    isOpen &&
    css`
      border: 1px solid ${() => Palette.Primary._300};
      box-shadow: 0px 0px 0px 3px rgba(59, 137, 246, 0.16);
    `}
`;

export const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const DropDownListContainer = styled('div')`
  position: absolute;
  right: 20px;
  z-index: 1000000;
  margin-top: 0.8em;
  box-shadow: 0px 16px 24px rgba(23, 43, 77, 0.04), 0px 16px 32px rgba(23, 43, 77, 0.08);
  ${({ isOpen }) =>
    isOpen
      ? css`
          visibility: visible;
          opacity: 1;
        `
      : css`
          visibility: hidden;
          opacity: 0;
        `}
  transition: all 0.2s linear;
`;

export const DropDownList = styled('ul')`
  padding: 0;
  margin: 0;
  background: #ffffff;
  border: 2px solid ${() => Palette.PrimaryGray._200};
  border-radius: 4px;
  box-sizing: border-box;
  color: ${() => Palette.PrimaryGray._700};
  padding: 8px 8px;
  max-height: 200px;
  overflow: auto;

  ::-webkit-scrollbar {
    width: 6px;
    background-color: #ffffff;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: ${() => Palette.PrimaryGray._300};
  }
  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #ffffff;
  }
`;

export const ListItem = styled('li')`
  list-style: none;
  padding-left: 8px;
  padding-right: 8px;
  height: 40px;
  display: flex;
  align-items: center;
  border: 1px solid white;
  span {
    text-transform: capitalize;
    margin-right: 16px;
    svg {
      fill: ${Palette.PrimaryGray._400};
    }
  }
  :hover {
    color: ${() => Palette.PrimaryGray._900};
    border-radius: 4px;
    background: ${() => Palette.PrimaryGray._100};
    span {
      svg {
        fill: ${Palette.Primary._500};
      }
    }
  }
  :active {
    border: 1px solid ${() => Palette.Primary._300};
    color: ${() => Palette.Primary._500};
  }
  transition: all 0.1s linear;
`;
